import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentHelper, DirectionBadge } from 'fakturnia-shared';

/**
 * Komponent wyświetlający badge kierunku transakcji dokumentu.
 * 
 * Użycie:
 * ```html
 * <direction-badge [document]="document"></direction-badge>
 * <direction-badge [document]="document" [size]="'sm'"></direction-badge>
 * ```
 */
@Component({
  selector: 'direction-badge',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './direction-badge.component.html',
  styleUrl: './direction-badge.component.scss'
})
export class DirectionBadgeComponent {
  
  /**
   * Dokument dla którego wyświetlamy badge
   */
  @Input() document: any;
  
  /**
   * Rozmiar badge: 'sm' (8x8), 'md' (10x10), 'lg' (12x12)
   */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get badge(): DirectionBadge {
    if (!this.document) {
      return {
        text: '',
        icon: 'tabler_outline:file',
        bgClass: 'bg-gray-100 dark:bg-gray-800',
        iconClass: 'text-gray-500 dark:text-gray-400'
      };
    }
    return DocumentHelper.getDirectionBadge(this.document);
  }

  get sizeClasses(): string {
    switch (this.size) {
      case 'sm': return 'w-8 h-8';
      case 'lg': return 'w-12 h-12';
      case 'md':
      default: return 'w-10 h-10';
    }
  }

  get iconSizeClass(): string {
    switch (this.size) {
      case 'sm': return 'icon-size-4';
      case 'lg': return 'icon-size-6';
      case 'md':
      default: return 'icon-size-5';
    }
  }
}
